<template>
  <div class='attachments'>
    <span class='label' :style='labelStyle'>{{labelText}}:</span>
    <div class='attachmentsContent'>
      <myUpload
        field='file'
        @crop-success='cropSuccess'
        @crop-upload-success='cropUploadSuccess'
        @crop-upload-fail='cropUploadFail'
        v-model='showBigImage'
        :width='width'
        :height='height'
        noCircle
        :url='attachmentsUploadUrl'
        :params='{type: typeNum}'
      ></myUpload>
      <div
        class='defaultAdd'
        style='width: 150px; height: 150px'
        v-if='!value'
      >
        <i class='el-icon-plus' style='color: #999; font-size: 20px'></i>
      </div>
      <img :src='value' class='upload-image' v-if='value' />
      <div class='input-box'>
        <el-button type='primary' class='UpImgBtn' @click='toggleShow'>upload</el-button>
        <span>点击选择图片，图片大小为{{width}}*{{height}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import myUpload from 'vue-image-crop-upload'
export default {
  name: 'imageUpload',
  components: {
    myUpload
  },
  props: {
    label: String,
    value: '',
    labelWidth: String,
    width: Number,
    height: Number,
    type: Number
  },
  data () {
    return {
      imageUrl: this.value,
      showBigImage: false,
      attachmentsUploadUrl: pubServer + '/upload/upload',
      // attachmentsUploadUrl: 'https://uat-nikegetit2.nike.com/public-service-new/upload/upload',
      labelText: this.label || '图片上传',
      typeNum: this.type || 6
    }
  },
  methods: {
    toggleShow () {
      this.showBigImage = !this.showBigImage
    },
    cropSuccess (imgDataUrl, field) {},
    cropUploadSuccess (jsonData, field) {
      this.imageUrl = jsonData.data.result.imageUrl
      this.$emit('input', this.imageUrl)
    },
    cropUploadFail (status, field) {}
  },
  computed: {
    labelStyle () {
      const w = this.labelWidth || '100'
      return {
        width: w + 'px'
      }
    }
  },
  watch: {
    value: function (val, oldVal) {
      this.imageUrl = val
    }
  }
}
</script>

<style scoped lang='sass'>
  .attachments
    display: flex
    margin-bottom: 20px
    .label
      text-align: right
      vertical-align: middle
      float: left
      font-size: 14px
      color: #606266
      line-height: 36px
      padding: 0 12px 0 0
      -webkit-box-sizing: border-box
      box-sizing: border-box
      flex-shrink: 0
    .input-box
      font-size: 12px
      color: #606266
      span
        margin-left: 5px
    .defaultAdd
      border: 1px dashed #ccc
      display: flex
      align-items: center
      justify-content: center
      background: #fff
      margin-bottom: 10px
      i
        color: #999
        font-size: 20px
    .attachmentsContent
      line-height: 36px
      width: 100%
      .upload-image
        width: 150px
</style>



// WEBPACK FOOTER //
// src/openSurvey/components/imageUpload.vue